import { render, staticRenderFns } from "./UploadFileBtn.vue?vue&type=template&id=68d07fa0&scoped=true"
import script from "./UploadFileBtn.vue?vue&type=script&lang=js"
export * from "./UploadFileBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadFileBtn.vue?vue&type=style&index=0&id=68d07fa0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d07fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d07fa0')) {
      api.createRecord('68d07fa0', component.options)
    } else {
      api.reload('68d07fa0', component.options)
    }
    module.hot.accept("./UploadFileBtn.vue?vue&type=template&id=68d07fa0&scoped=true", function () {
      api.rerender('68d07fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Upload/UploadFileBtn.vue"
export default component.exports